<template>
  <div class="guided-search-content__stepper">
    <a href="/"><span :alt="$companyName" class="logo" /></a>
    <horizontal-stepper
      class="gs-stepper__horizontal"
      :steps="steps"
      :actual-step="actualStep"
      stepper-type="guided-search"
      :icon-info="false"
    />
  </div>
</template>

<script>
import HorizontalStepper from '@components-molecules/Steppers/HorizontalStepper.vue';
import guidedSearchMixin from './guidedSearchMixin';

export default {
  name: 'Stepper',
  components: { HorizontalStepper },
  mixins: [ guidedSearchMixin ],
  data() {
    return {};
  },
};
</script>
